import { useGuide } from '@knocklabs/react';

import './KnockGuideCard.css';

import { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

import { track } from 'support/helpers/analytics/analytics';
import { Button } from 'components/Form/Button';

export const KnockGuideCard = () => {
  const { step: knockGuide, guide: meta } = useGuide({ type: 'dashboard-card' });

  useEffect(() => {
    if (knockGuide) {
      knockGuide.markAsSeen();
    }
  }, [knockGuide]);

  if (!knockGuide || !meta) {
    return null;
  }

  const primaryButton = knockGuide.content.primary_button;
  const secondaryButton = knockGuide.content.secondary_button;

  return (
    <div className="relative overflow-hidden rounded-3xl border border-gray-200 bg-white p-6 text-gray-900">
      <div
        className="absolute top-0 right-0 h-48 w-90"
        style={{ background: 'linear-gradient(47deg, #c9d3fc00 48.97%, #e7fbf7 100%)' }}
      />
      <div className="relative flex items-start">
        <div className="relative flex flex-1 flex-col items-start gap-4 pr-4">
          <div className="text-base leading-6 font-bold">{knockGuide.content.title}</div>
          <div
            className="dashboardKnockGuideCard__body text-sm leading-5 font-normal"
            dangerouslySetInnerHTML={{ __html: knockGuide.content.body }}
          />

          <div className="mt-4 flex items-center justify-start gap-3">
            {primaryButton ? (
              <Button
                variant="primary"
                size="base"
                analyticsId={`knock_guide:${meta.key}_click_primary`}
                onClick={() => {
                  track(`knock_guide:${meta.key}_click_primary`);
                  knockGuide.markAsInteracted({ metadata: { action: `${meta.key}:clicked_primary` } });
                  window.open(primaryButton.action, '_blank');
                  knockGuide.markAsArchived();
                }}
              >
                {primaryButton.text}
              </Button>
            ) : null}
            {secondaryButton ? (
              <Button
                variant="secondary"
                size="base"
                analyticsId={`knock_guide:${meta.key}_click_secondary`}
                onClick={() => {
                  track(`knock_guide:${meta.key}_click_secondary`);
                  knockGuide.markAsInteracted({ metadata: { action: `${meta.key}:clicked_secondary` } });
                  window.open(secondaryButton.action, '_blank');
                }}
              >
                {secondaryButton.text}
              </Button>
            ) : null}
          </div>
        </div>
        <Button
          iconOnly
          size="extra-small"
          variant="minimal"
          LeftIcon={XMarkIcon}
          onClick={() => {
            knockGuide.markAsArchived();
          }}
          analyticsId={`knock_guide:${meta.key}_click_archive`}
        />
      </div>
    </div>
  );
};
